import Header from "./Header";
import Footer from "./Footer";
import TrialBanner from "@/components/TrialBanner";

export default function PageShell({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <TrialBanner />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
